import {
    Config,
    REFERRAL_OFFER_IDS,
    getPersonalReferralIdFromCookie,
} from '@ratehub/base-ui';


/**
 * Is this credit card eligible for a referral offer, based on the arguments provided associated with the card and
 * other relevant factors, including a referral cookie being present?
 *
 * @param {object} args
 * @param {boolean} [args.hasGiftCardOffer = false] - any giftCardOffer takes precedence, causing this function to return false
 * @param {boolean} [args.hasReferralOffer = false] - has this card been made eligible for a referral bonus?
 * @return {boolean}
 */
function isCardEligibleForReferralOffer({ hasGiftCardOffer = false, hasReferralOffer = false }) {
    return Config.ENABLE_CC_REFERRAL_OFFERS
        && hasReferralOffer
        && !hasGiftCardOffer
        && getPersonalReferralIdFromCookie(REFERRAL_OFFER_IDS.creditCard) !== null;
}


export default isCardEligibleForReferralOffer;
